import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const ParagraphSpacingUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const ParagraphSpacingValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const ParagraphSpacingTokenData = tokenAliasOrValue(ParagraphSpacingValue);
